import React from 'react';
import { Stack } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import PaiTextField from 'features/ui/base-components/pai-text-field';
import { BasicActionDialog } from 'features/ui/base-dialogs';

interface Props {
  open: boolean;
  loading: boolean;
  firstName: string;
  lastName: string;

  handleFirstNameChange(event: React.ChangeEvent<HTMLInputElement>): void;
  handleLastNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;
  handleEditName(): void;
}

const EditContactNameDialog: React.FC<Props> = ({
  open,
  loading,
  firstName,
  lastName,
  handleFirstNameChange,
  handleLastNameChange,
  handleClose,
  handleEditName
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <BasicActionDialog
      open={open}
      loading={loading}
      dialogTitle={t('editContactName')}
      maxWidth="xs"
      proceedButtonText={t('save')}
      handleProceed={handleEditName}
      proceedButtonDisabled={firstName.trim() === '' || lastName.trim() === ''}
      cancelButtonText={t('cancel')}
      handleClose={handleClose}
    >
      <Stack spacing={2} className={classes.dialogContent}>
        <PaiTextField
          label={t('firstName')}
          placeholder={t('enterContactNameHere')}
          value={firstName}
          onChange={handleFirstNameChange}
        />
        <PaiTextField
          label={t('lastName')}
          placeholder={t('enterContactNameHere')}
          value={lastName}
          onChange={handleLastNameChange}
        />
      </Stack>
    </BasicActionDialog>
  );
};

const useStyles = makeStyles()(() => ({
  dialogContent: {
    // e.g. marginTop: theme.spacing(1),
  }
}));

export default EditContactNameDialog;
